import React, { h } from "preact";
import { t } from '../_i18n'
import { F, E } from "../_common/layout";
import { AppPage } from '../_common/components/app-page'
import { useEffect, useState } from 'preact/hooks';
import { useHistory } from 'react-router'
import { Checkbox } from "../_common/forms/components/Checkbox/Checkbox";
import * as ReactDOM from 'react-dom'
import { Link } from "react-router-dom";

import { Comunicados } from "./comunicados";

export function ComunicadosPage() {

    const [check, setCheck] = useState(false)

    const history = useHistory();

    const ShowOpened = () =>
        <Checkbox
            onChange={
                (e) => handleCheck(e)
            }
            value={check}
            labelIsClicked={true}
            label={
                <span>
                    {t('show_only_unread_notices')}
                </span>
            }
        />

    // we add the checkbox to who only unread notices to main page
    useEffect(() => {
        if(document.querySelectorAll(".notice-unread").length !== 0 && document.querySelectorAll(".notice-read").length !== 0 ){
            var div = document.createElement("div");
            div.id = 'showOpened';
            document.querySelector("h1") 
            && document.querySelector("h1").appendChild(div)
            && ReactDOM.render(
                <ShowOpened />,
                document.querySelector("#showOpened"),
            );
        }
    }, []);

    // triggered every time "check" value changes, so after setCheck call
    useEffect(() => {
        // Force checkbox visual 
        var checkbox = document.querySelector(".checkbox-component");
        if (checkbox) checkbox.checked = check;
        if (document.querySelector(".card.notice-read")) {
            if (check) document.querySelectorAll(".card.notice-read").forEach(c => c.closest('.wrapped-list').style.display = 'none');
            else document.querySelectorAll(".card.notice-read").forEach(c => c.closest('.wrapped-list').style.display = 'block');
        }
    },[check]);    

    const handleCheck = (e) => {
        setCheck(e);
      };

    return (
        <AppPage
            name="comunicados-page"
            title={t('Comunicados')}
            back={history.goBack}
            className="max-width-980">
            <F className="max-width-980 comunicados">
                <Comunicados />
            </F>
        </AppPage>
    )
}
